module.exports = __webpack_public_path__ + "media/images/location-5619655ce15d8d795cd2876a1493b106.svg";